exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".do-not-hire-form-wrapper,.do-not-hire-form-wrapper form{width:100%}.do-not-hire-form-wrapper form input[type=text]{width:100%;height:35px;border:1px solid #c9d5da;border-radius:6px;margin-top:17px;padding-left:15px}.do-not-hire-form-wrapper form input[type=text].email-has-error{border:1px solid red}.dnh-users-list{font-weight:900}table.do-not-hire-table{width:100%;margin-top:20px}table.do-not-hire-table thead tr th{border-bottom:1px solid #c9d5da;font-weight:400;font-size:14px;padding-bottom:2px;margin-bottom:12px}table.do-not-hire-table tbody tr td{padding-top:5px;padding-bottom:5px}table.do-not-hire-table tbody tr td:last-child i:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/accountprofile/posttypes/posttypes.css
// module id = 622
// module chunks = 0